import React, { useEffect, useState } from 'react'
import { Card, Form, InputNumber, Select, Button, Typography, App, Space, Alert } from 'antd'
import { apiClient } from '@/services/api'

const { Title, Paragraph, Text } = Typography
const { Option } = Select

const PaymentTestPage: React.FC = () => {
  const { message } = App.useApp()
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<any>(null)
  const [methods, setMethods] = useState<any[]>([])
  const [testConfig, setTestConfig] = useState<{ testMode: boolean; testAmountMax: number | null }>({ testMode: false, testAmountMax: null })

  useEffect(() => {
    // 加载可用支付方式
    (async () => {
      try {
        const res = await apiClient.get('/payment/methods')
        if (res.success) setMethods(res.data?.methods || [])
      } catch {}
    })()
    // 加载测试模式配置（仅展示）
    ;(async () => {
      try {
        const res = await apiClient.get('/admin/payment/test/health', { params: { t: Date.now() } as any })
        if (res.success) {
          setTestConfig({ testMode: !!res.data?.payments?.testMode, testAmountMax: res.data?.payments?.testAmountMax ?? null })
        }
      } catch {}
    })()
  }, [])

  const onFinish = async (values: any) => {
    try {
      setLoading(true)
      const payload = {
        amount: Number(values.amount) || 0.01,
        credits: Number(values.credits) || 1,
        paymentMethod: values.paymentMethod || 'wechat',
        scene: 'test'
      }
      const res = await apiClient.post('/admin/payment/test/create-order', payload)
      if (!res?.success) throw new Error(res?.message || '创建测试单失败')
      setResult(res.data)
      message.success('测试单已创建')
    } catch (e: any) {
      message.error(e?.message || '创建测试单失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-3xl mx-auto p-4">
      <Card className="shadow-md">
        <Title level={3}>🧪 小额支付测试</Title>
        <Paragraph type="secondary">根据当前支付网关配置创建 0.01 元测试订单，用于联调验证（标记为测试单，不计入营收）。</Paragraph>

        <Alert
          className="mb-3"
          showIcon
          type={testConfig.testMode ? 'success' : 'warning'}
          message={testConfig.testMode ? '测试模式已开启' : '测试模式未开启'}
          description={
            <div>
              <div>阈值：金额 ≤ {testConfig.testAmountMax ?? '未设置'} 元将被识别为测试单。</div>
              <div>如需修改，请到 管理控制台 → 系统设置 → 支付配置 → 测试设置。</div>
            </div>
          }
        />

        <Form layout="vertical" onFinish={onFinish} initialValues={{ amount: 0.01, credits: 1, paymentMethod: 'wechat' }}>
          <Form.Item label="支付金额 (¥)" name="amount" rules={[{ required: true }]}>
            <InputNumber min={0.01} max={10} step={0.01} precision={2} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="充值积分（仅展示用途）" name="credits" rules={[{ required: true }]}>
            <InputNumber min={1} max={9999} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item label="支付方式" name="paymentMethod" rules={[{ required: true }]}>
            <Select>
              {(methods.length > 0 ? methods : [{ id: 'wechat', name: '微信支付', enabled: true }])
                .filter((m: any) => m.enabled)
                .map((m: any) => (
                  <Option key={m.id} value={m.id}>{m.name || m.id}</Option>
                ))}
            </Select>
          </Form.Item>

          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>创建测试订单</Button>
            <Button onClick={async () => {
              try {
                const r = await apiClient.get('/admin/payment/test/orders', { params: { page: 1, limit: 10, t: Date.now() } as any })
                setResult(r?.data || r)
              } catch {}
            }}>查看测试订单</Button>
          </Space>
        </Form>

        {result && (
          <Card className="mt-4" size="small" title="返回结果">
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0 }}>
{JSON.stringify(result, null, 2)}
            </pre>
            {result?.paymentUrl && (
              <div className="mt-2"><Text type="secondary">可在手机端使用微信打开 paymentUrl 进行联调。</Text></div>
            )}
          </Card>
        )}
      </Card>
    </div>
  )
}

export default PaymentTestPage


